import React from 'react';
// styles
import styled from 'styled-components';

const expandIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Expand"
    className={className}
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_2549_35387)">
      <path
        d="M12.2491 0.260816C11.9368 0.478814 11.7236 0.811652 11.6561 1.18648C11.5887 1.56131 11.6724 1.9476 11.8891 2.26082L18.4721 11.7278C18.5282 11.8083 18.5583 11.9042 18.5583 12.0023C18.5583 12.1005 18.5282 12.1963 18.4721 12.2768L11.8891 21.7398C11.7812 21.8951 11.7048 22.0701 11.6645 22.2549C11.6242 22.4397 11.6207 22.6306 11.6542 22.8167C11.6877 23.0029 11.7575 23.1806 11.8596 23.3397C11.9618 23.4989 12.0943 23.6364 12.2496 23.7443C12.4049 23.8523 12.5799 23.9286 12.7647 23.9689C12.9495 24.0092 13.1404 24.0127 13.3265 23.9792C13.5126 23.9457 13.6904 23.8759 13.8495 23.7738C14.0087 23.6716 14.1462 23.5391 14.2541 23.3838L20.8361 13.9208C21.2261 13.3571 21.4351 12.6878 21.4351 12.0023C21.4351 11.3168 21.2261 10.6476 20.8361 10.0838L14.2541 0.620817C14.1461 0.465484 14.0086 0.33295 13.8494 0.230785C13.6902 0.128619 13.5124 0.0588277 13.3262 0.0253956C13.14 -0.00803638 12.949 -0.00445249 12.7642 0.0359413C12.5794 0.0763351 12.4044 0.152749 12.2491 0.260816Z"
        fill="white"
      />
      <path
        d="M7.52695 23.1105L14.1109 13.6475C14.4451 13.1641 14.624 12.5905 14.624 12.003C14.624 11.4154 14.4451 10.8418 14.1109 10.3585L7.52695 0.89446C7.43839 0.767576 7.32051 0.663951 7.18332 0.592395C7.04613 0.520839 6.89368 0.483468 6.73895 0.483461L3.52595 0.48346C3.35062 0.4835 3.17865 0.531558 3.02869 0.622416C2.87874 0.713275 2.75654 0.843463 2.67533 0.998856C2.59413 1.15425 2.55704 1.32892 2.56808 1.5039C2.57912 1.67888 2.63787 1.8475 2.73795 1.99146L9.32095 11.4545C9.43299 11.616 9.49303 11.8079 9.49303 12.0045C9.49303 12.201 9.43299 12.3929 9.32095 12.5545L2.73795 22.0185C2.63896 22.1624 2.58112 22.3306 2.57066 22.505C2.5602 22.6793 2.59751 22.8533 2.67858 23.008C2.75965 23.1627 2.8814 23.2924 3.03072 23.3831C3.18004 23.4737 3.35126 23.5219 3.52595 23.5225L6.73895 23.5225C6.89378 23.5224 7.04631 23.4849 7.18353 23.4132C7.32074 23.3415 7.43856 23.2376 7.52695 23.1105Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2549_35387">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(24 24) rotate(-180)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default styled(expandIcon)``;
